import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('webs-highlight-general')
export class HighlightGeneral extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-highlight-general .wrapper {
          background: var(--color-light-grey);
          color: var(--color-dark-grey);
          border-radius: 16px;
          font-weight: normal;
          overflow: hidden;
      }

      .m-highlight-general__visual {
        position: relative;
        margin-bottom: 1.5rem;

      }



      .m-highlight-general__content {
        padding: 1rem;

      }

      .m-highlight-general__content--tag {
        color: var(--color-orange);
        font-family: var(--font-family-alternative);
        text-transform: uppercase;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 0.7rem;
      }

      .m-highlight-general__quote {
        margin-top: 1.2rem;
      }

       .m-highlight-general__content--actions {
        margin: 2rem 0;
       }

       .m-highlight-general-event-tag,
        .m-highlight-general-logo {
        position: absolute;
        right: 1.2rem;
        top: 1.2rem;
        z-index: 100;
       }

      @media only screen and (min-width: 576px){
       .m-highlight-general__content {
          padding: 2rem;
          }
      }

      @media only screen and (min-width: 768px){
           .m-highlight-general__content {
              padding: 0;
              padding-left: 3rem;
               margin: 2.5rem 0;

      }

          .m-highlight-general__visual {
              margin-bottom: 0;
              margin-top: auto;
          }
      }
    `
  ];

  @property()
  id: string;

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'media-position'})
  mediaPosition = 'right';

  @property()
  title: string;

  @property()
  tag: string;

  @property({attribute: 'logo-src'})
  logoSrc: string;

  @property({attribute: 'event-tag'})
  eventTag: string;


  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
               class="m-highlight-general ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="container">
          <div class="wrapper ">
            <webs-grid-row  reverse="${this.mediaPosition === 'right' ? 'sm' : 'none'}">
              <webs-grid-column sm="5" md="6" class="m-highlight-general__visual">
                ${this.logoSrc ? html`
                  <webs-logo class="m-highlight-general-logo" src="${this.logoSrc}" alt="Logo" loading="lazy" width="120"></webs-logo>
                `:""}
                ${this.eventTag ? html`
                  <webs-tag  class=" m-highlight-general-event-tag"  text="${this.eventTag}" gradient=""></webs-tag>
                `:""}
                <slot name="media"></slot>
              </webs-grid-column>
              <webs-grid-column sm="7"  md="6" class="m-highlight-general__content">
                ${this.tag ? html` <h5 class="m-highlight-general__content--tag">${this.tag}</h5>` : ''}
                ${this.title ? html` <h3>${ this.title }</h3>` : ''}
                <slot name="description"></slot>
                <div class="m-highlight-general__quote">
                    <slot name="quote"></slot>
                </div>
                <div class="m-highlight-general__content--actions">
                  <slot name="action"></slot>
                </div>
              </webs-grid-column>
            </webs-grid-row >
          </div>
        </div>
      </section>
    `
  }
}
